import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import moment from 'moment/moment';
import S3DownloadButton from './s3-download-button';

class SendEmailHistoryStore {
    @observable emails = [];

    constructor(appStore) {
        this.appStore = appStore;
    }
}

class TransitionRow extends Component {
    constructor() {
        super();
    }

    render() {
        const createdOn = moment(this.props.transition.createdOn);

        return (
            <div className="transition-row">
                <hr className="section-header" />
                <div className="row email">
                    <div className="col-xs-12 col-sm-12">
                        <h5>{`Note added on ${moment(createdOn).format('L LT')}`}</h5>
                    </div>
                    <div className="col-xs-12 col-sm-12">{this.props.transition.reasons.join(', ')}</div>
                </div>
            </div>
        );
    }
}

class EmailHistoryRow extends Component {
    constructor() {
        super();
        this.state = {
            expanded: false,
        };
    }

    toggleExpand(evt) {
        evt.preventDefault();
        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        const sentDate = moment(this.props.email.sentDate),
            attachedFiles =
                this.props.email.attachments && this.props.email.attachments.length > 0 ? (
                    <div className="attachments">
                        {_.map(this.props.email.attachments, (attachment) => {
                            return (
                                <div key={attachment.fileKey} className="xs-col-6">
                                    <S3DownloadButton bsStyle="link" fileKey={attachment.fileKey}>
                                        {attachment.file.name}
                                    </S3DownloadButton>
                                </div>
                            );
                        })}
                    </div>
                ) : null;
        return (
            <div className="email-step">
                <hr className="section-header" />
                <div className="row email">
                    <div className="col-xs-12 col-sm-12">
                        <h5>
                            {`Email was sent on ${moment(sentDate).format('L LT')}`}
                            <i
                                className={`fa ${
                                    this.state.expanded ? 'fa-minus-square' : 'fa-plus-square'
                                } pull-right clickable`}
                                onClick={this.toggleExpand.bind(this)}
                            />
                        </h5>
                    </div>
                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <span className="title">To:</span> <span>{this.props.email.toEmails.join(', ')} </span>
                    </div>
                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <span className="title">Cc:</span>
                        <span> {this.props.email.ccEmails.join(', ')} </span>
                    </div>
                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <span className="title">Bcc:</span> <span>{this.props.email.bccEmails.join(', ')} </span>
                    </div>
                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <span className="title">From:</span>
                        <span> {this.props.email.fromEmail} </span>
                    </div>

                    <div className="col-xs-12 col-sm-12 email-attribute">
                        <span className="title">Subject:</span>
                        <span> {this.props.email.subject} </span>
                    </div>

                    {this.state.expanded ? (
                        <div className={'col-xs-12 col-sm-12'}>
                            <div className="body" dangerouslySetInnerHTML={{ __html: this.props.email.body }}></div>
                        </div>
                    ) : null}
                    {this.state.expanded ? <div className="col-xs-12 col-sm-12">{attachedFiles}</div> : null}
                </div>
            </div>
        );
    }
}

@inject('appStore')
@observer
export default class StepHistory extends Component {
    constructor(props) {
        super(props);
        this.store = new SendEmailHistoryStore(props.appStore);
    }

    render() {
        const mappedEmails = this.props.emails.map((email) => {
            return {
                date: email.sentDate,
                type: 'email',
                data: email,
            };
        });
        const mappedTransitions = this.props.transitions.map((transition) => {
            return {
                date: transition.createdOn,
                type: 'transition',
                data: transition,
            };
        });

        const rows = mappedEmails.concat(mappedTransitions);

        rows.sort((a, b) => {
            if (b === undefined) return 1;
            if (a === undefined) return -1;

            const aDate = new Date(a.date),
                bDate = new Date(b.date);
            if (aDate > bDate) return 1;
            if (bDate < aDate) return -1;
            if (aDate === bDate) return 0;
        });
        return (
            <div className={'email-history'}>
                {rows.reverse().map((item) => {
                    if (item.type === 'email') {
                        return <EmailHistoryRow key={item.id} email={item.data} />;
                    }
                    if (item.type === 'transition') {
                        return <TransitionRow key={item.id} transition={item.data} />;
                    }
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/step-history.js